import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.21 4.474v1.24h7.664v-1.24zM4.79 3c-.582 0-1.053.471-1.053 1.053v2.083c0 .581.471 1.052 1.052 1.052h8.506c.581 0 1.052-.47 1.052-1.052V4.053c0-.582-.47-1.053-1.052-1.053zM3 8.584c0-.406.33-.736.737-.736h7.295a.737.737 0 0 1 0 1.473H3.737A.737.737 0 0 1 3 8.584m1.99 7.679c0-.407.33-.737.736-.737h8.621a.737.737 0 0 1 0 1.474h-8.62a.737.737 0 0 1-.738-.737m2.874-4.111v1.241h7.663v-1.24zm-.42-1.473c-.582 0-1.054.47-1.054 1.052v2.083c0 .582.472 1.053 1.053 1.053h8.505c.582 0 1.053-.471 1.053-1.053v-2.083c0-.581-.471-1.052-1.053-1.052z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=BaselineIcon20.js.map